import styles from "./insight-post-cover.module.css";
import coverImg from "../../../images/_finais/insights-post_details_compress.webp";

interface IProps {
  title: string;
  alt: string;
}

const InsightPostCover = ({ title, alt }: IProps) => {
  return (
    <section className={styles.cover_section}>
      <img
        className={styles.coverImg}
        src={coverImg}
        alt={alt}
        loading="lazy"
      />
    </section>
  );
};

export default InsightPostCover;
